import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageHeader: {
		id: 'admin-pages-screens-page.page-header',
		defaultMessage: 'Screens',
		description: 'Header of Screens Page',
	},
	addScreen: {
		id: 'admin-pages-screens-page.add-screen',
		defaultMessage: 'Add screen',
		description: 'Add screen button text',
	},

	successFlagTitle: {
		id: 'admin-pages-screens-page.success-flag-title',
		defaultMessage: 'Screen added successfully',
		description: 'Screen add was successfull title',
	},
	errorFlagTitle: {
		id: 'admin-pages-screens-page.error-flag-title',
		defaultMessage: 'Screen addition failed',
		description: 'Screen addition was a failure',
	},
	errorHeader: {
		id: 'admin-pages-screens-page.error-header',
		defaultMessage: 'An error occurred',
		description: 'Empty state message header',
	},
	errorDescription: {
		id: 'admin-pages-screens-page.error-description',
		defaultMessage: 'There was a problem loading your screens.',
		description: 'Error state message description',
	},
});
